<div class="welcome-user-name-padding content-blue singleLine flowrootDisplay" role="heading" aria-level="2" *ngIf="outcome">
  <div class="history-breadcrumb mb-8px">
    <div *ngFor="let breadcrumbParts of navData?.crumbData">
      <div *ngIf="breadcrumbParts != navData?.crumbData[navData?.crumbData.length-1]" class="font-14 mt-8px">
        <div class="flex-display">
          <div class="overflow-elipses">
            {{breadcrumbParts}}
          </div>
          <div><img class="breadcrumbArrow overlay-bread-crumb-icon bread-crumb-Arrow" src="../../../../assets/icons/Arrow RightDown (Alt).svg" alt="Arrow Down"></div>
        </div>
      </div>
    </div>
  </div>
  <div class="float-L history-heading flex-display width-67">
    <div>
      <img src="../../../assets/icons/BookmarkAdd-Blue.svg" class="watch-image image-info mt-8px" alt="Page Heading">
    </div>
    <div>
      <h1 id="pageHeading" role="heading" class="generalHeader" [innerHTML]="navData?.crumbData[navData?.crumbData.length-1]">
      </h1>
    </div>
  </div>

</div>
<div class="mt-1rem ml-6"><p>{{pageStatus}}</p></div>
